module.exports = __webpack_public_path__ + "static/img/yaoqin_bg2.d17dc81.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/yaoqin_bg2.png
// module id = tZgv
// module chunks = 5